import { combineReducers } from 'redux-immutable'
import accountingReducer from './accounting-reducer'
import billingListReducer from './billing-list-reducer'
import billingGetReducer from './billing-get-reducer'
import billingUpdateReducer from './billing-update-reducer'
import billingExportReducer from './billing-export-reducer'
import payingListReducer from './paying-list-reducer'
import payingGetReducer from './paying-get-reducer'
import payingUpdateReducer from './paying-update-reducer'
import payingExportReducer from './paying-export-reducer'

export default combineReducers({
  accounting: accountingReducer,
  billingList: billingListReducer,
  billingGet: billingGetReducer,
  billingUpdate: billingUpdateReducer,
  billingExport: billingExportReducer,
  payingList: payingListReducer,
  payingGet: payingGetReducer,
  payingUpdate: payingUpdateReducer,
  payingExport: payingExportReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/accounting-dashboard/index.js